module.exports = __webpack_public_path__ + "static/windows81-d1e2ba6e8d690c98fc3aad526542f361.png";